export function required(paramName) {
    throw `${paramName} is required`;
}